import router from './router'
import { request } from './untils/request'

window.startTime = new Date().getTime()/1000;
router.beforeEach((to, from, next) => {
    let params = {
        // 从哪里来
        fromPath: from.fullPath,
        // 到那里去
        toPath: to.fullPath,
        // 来源
        referrer: document.referrer,
        // 模块名称
        moduleName: to.meta.parentModule || to.meta.title,
        // 子模块名称
        subModuleName: to.query.title || to.meta.title
    }
    let resParams = {
        resId: to.query.id || to.params.id,
        moduleName: to.meta.parentModule || to.meta.title,
    }
    try {
        if (params.moduleName) {
            request('post', '/nlc-web/api/websiteData', params)
        }
        if (resParams.resId) {
            request('post', '/nlc-web/api/websiteData/res', resParams)
        }
    } catch (e) {

    }
    next()
})

router.afterEach((to, from) => {
    /**
     * 模块、子模块、访问ip、停留时长、创建时间
     * @type {string}
     */
    let params = {
        // 资源id
        resourceId: from.query.id || from.params.id,
        // 模块名称
        moduleName: from.meta.parentModule || from.meta.title,
        // 子模块名称
        subModuleName: from.query.title || from.meta.title
    }
    let endTime = new Date().getTime()/1000
    if (endTime!==window.startTime) {
        // 停留时长
        params.keepTime = Math.ceil(endTime-window.startTime)
    }
    window.startTime = new Date().getTime()/1000;
    try {
        if (params.moduleName) {
            request('post', '/nlc-web/api/websiteData/keepTime', params)
        }
    } catch (e) {

    }
})



// WEBPACK FOOTER //
// ./src/permission.js